import { CounterPill, Crumblist, Table } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { Col3Col9, NoValue } from '../';
import ContentConstants from '../../../contentConstants';
import { ISummaryItem, SurveyStep } from '../../../models';
import { IHierarchyReportingAccessConfig } from '../../../models/IHierarchyReportingAccessConfig';
import { getGroupTypeLabels } from '../../../utilities/GroupTypeEnumHelper';
import { ErrorWarningDisplay } from './ErrorWarningDisplay';
import { DisplayName, DisplayValue, RowSummaryItemLayout } from './RowSummaryItem';

export const BulkReportingAccessSummaryItemLayout = styled.div.attrs<{}>({
	className: 'tws-bulk-reporting-access-summary-item',
})``;

export class BulkReportingAccessSummaryItem extends React.Component<ISummaryItem> {
	public render() {
		const { displayName, errors, warnings } = this.props;

		const { totalUsers, hierarchyConfigs } = this.props.value as {
			hierarchyConfigs: IHierarchyReportingAccessConfig[];
			totalUsers: number;
		};
		const hasConfigs = hierarchyConfigs && hierarchyConfigs.length > 0;
		const hasErrorsOrWarnings = (errors && errors.length > 0) || (warnings && warnings.length > 0);

		return (
			<Col3Col9 label={displayName} subLabelDisplayData={<CounterPill actualCount={totalUsers} />}>
				<BulkReportingAccessSummaryItemLayout>
					{hasErrorsOrWarnings && <ErrorWarningDisplay errors={errors} warnings={warnings} />}
					{hasConfigs && (
						<Table>
							<tbody>
								{hierarchyConfigs.map((config) => (
									<tr key={config.hierarchyReportingAccessConfigId}>
										<td>
											<RowSummaryItemLayout>
												<DisplayName>{ContentConstants.HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_HIERARCHY}</DisplayName>
												<DisplayValue>{config.hierarchyName}</DisplayValue>
											</RowSummaryItemLayout>
											<RowSummaryItemLayout>
												<DisplayName>{ContentConstants.HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_REPORTING_USERS_COUNT}</DisplayName>
												<DisplayValue>
													{config.userCount}
													{/* Todo: probably shouldn't bake validation logic into the display.
											 	Need way to show backend error/warning on nested property */}
													{config.userCount === 0 && (
														<ErrorWarningDisplay
															warnings={[
																{
																	message:
																		'None of the people with group access in the selected hierarchy are in the selected profile(s) below.',
																	relatedStep: SurveyStep.Reporting,
																},
															]}
														/>
													)}
												</DisplayValue>
											</RowSummaryItemLayout>
											<RowSummaryItemLayout>
												<DisplayName>{ContentConstants.HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_PROFILES}</DisplayName>
												<DisplayValue>
													<Crumblist
														data={config.groupAccessProfiles.map((p) => ({
															value: p.profileId,
															displayText: p.name,
														}))}
													/>
												</DisplayValue>
											</RowSummaryItemLayout>
											<RowSummaryItemLayout>
												<DisplayName>{ContentConstants.HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_SCOPEGROUPS}</DisplayName>
												<DisplayValue>
													<Crumblist
														data={getGroupTypeLabels(config.scopeGroupTypes).map((g) => ({
															value: g,
															displayText: g,
														}))}
													/>
												</DisplayValue>
											</RowSummaryItemLayout>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					)}
					{!hasConfigs && !hasErrorsOrWarnings && NoValue}
				</BulkReportingAccessSummaryItemLayout>
			</Col3Col9>
		);
	}
}
